/**
 * Mobile size charts: product-page tables with few rows and many columns (e.g. Bont sizes,
 * 7 rows x 20 sizes) are shown transposed on mobile, one row per size, instead of scrolling
 * sideways. The original table stays in place for desktop; CSS in product-page.css picks one.
 * Tables with merged cells are left untouched.
 */
(() => {
  const MAX_ROWS = 8;

  const qualifies = (table) => {
    const rows = Array.from(table.rows);
    if (!rows.length || rows.length > MAX_ROWS) return false;
    const cols = Math.max(...rows.map((row) => row.cells.length));
    if (cols < 8 || cols < rows.length * 2) return false;
    return !table.querySelector('[colspan]:not([colspan="1"]), [rowspan]:not([rowspan="1"])');
  };

  const transpose = (table) => {
    const rows = Array.from(table.rows);
    const cols = Math.max(...rows.map((row) => row.cells.length));
    const result = document.createElement('table');
    result.className = 'rc-table-transposed';
    const head = result.createTHead().insertRow();
    const body = result.createTBody();

    // Header labels are set vertically so the long names do not decide the column widths
    rows.forEach((row) => {
      const th = document.createElement('th');
      const label = document.createElement('span');
      th.scope = 'col';
      label.className = 'rc-table-transposed__label';
      label.innerHTML = row.cells[0] ? row.cells[0].innerHTML : '';
      th.appendChild(label);
      head.appendChild(th);
    });

    for (let c = 1; c < cols; c += 1) {
      const tr = body.insertRow();
      rows.forEach((row, r) => {
        const cell = document.createElement(r === 0 ? 'th' : 'td');
        if (r === 0) cell.scope = 'row';
        cell.innerHTML = row.cells[c] ? row.cells[c].innerHTML : '';
        tr.appendChild(cell);
      });
    }
    return result;
  };

  const run = (root) => {
    root.querySelectorAll('.shopify-section table:not([data-rc-transpose])').forEach((table) => {
      table.dataset.rcTranspose = 'skip';
      if (table.classList.contains('rc-table-transposed') || !qualifies(table)) return;
      table.dataset.rcTranspose = 'original';
      table.after(transpose(table));
    });
  };

  const init = () => {
    const main = document.getElementById('main-content') || document.body;
    run(main);
    // Variant changes re-render the details sections; batch DOM mutations per frame
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        run(main);
      });
    }).observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
